export const OPEN_PHOTO_STUDIO_EVENT = 'craftara:open-photo-studio';

export function openPhotoStudio() {
  window.dispatchEvent(new CustomEvent(OPEN_PHOTO_STUDIO_EVENT));
}
